class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.assignCardEvents();
    this.checkPersonalisedImages();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => { this.classList.add('animate', 'active') });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  setSubPriceSpacing() {
    const start = Date.now();
    const elements = [...document.getElementsByClassName('sub-price')];
    const fullPageElements = [...document.getElementsByClassName('fullpage-sub-price')];
    if (!elements.length) return;
    
    const cartItemTotals = document.getElementsByClassName('cart-item__totals right')[0];
    const cartItemDetails = document.getElementsByClassName('cart-item__details')[0];
    
    if (cartItemTotals && cartItemDetails) {
      const gap = cartItemTotals.getBoundingClientRect().left - cartItemDetails.getBoundingClientRect().right;
      const width = cartItemTotals.getBoundingClientRect().width;
      elements.forEach((element) => {
        const elementToEdge = cartItemDetails.getBoundingClientRect().right - element.parentElement.getBoundingClientRect().right;
        element.style.setProperty('--sub-price-offset', `${elementToEdge + gap + width}px`);
      });
    }
    
    if (fullPageElements.length) {
      const fullPageCartItemTotals = document.getElementsByClassName('fullpage-cart-item__totals right')[0];
      const fullPageCartItemDetails = document.getElementsByClassName('fullpage-cart-item__details')[0];
    
      if (fullPageCartItemTotals && fullPageCartItemDetails) {
        const gap = fullPageCartItemTotals.getBoundingClientRect().left - fullPageCartItemDetails.getBoundingClientRect().right;
        const width = fullPageCartItemTotals.getBoundingClientRect().width;
        fullPageElements.forEach((element) => {
          const elementToEdge = fullPageCartItemDetails.getBoundingClientRect().right - element.parentElement.getBoundingClientRect().right;
          element.style.setProperty('--sub-price-offset', `${elementToEdge + gap + width}px`);
        });
      }
    }
    // console.log(`repositioning subpricing took ${(Date.now() - start) / 1000} seconds`);
  }

  async handleQuickAddClick(event) {
    const { target } = event;

    let Message = "";
    if (document.getElementById('CartDrawer-Note')) {
      Message = document.getElementById('CartDrawer-Note').value;
    }

    // Find the product container for the clicked button
    const productContainer = target.closest('.twelve-days-inputs');
    let productId, personalizationMessage = "";

    if (productContainer) {
      productId = productContainer.dataset.productId;

      // Get the value from the relevant personalization text box
      const personalizationInput = document.querySelector(`.personalization-input[data-for-product="${productId}"]`);
      console.log("productId: ", productId);
      console.log("personalizationInput: ", personalizationInput);
      if (personalizationInput) {
        personalizationMessage = personalizationInput.value;
      }
    }

    const variantId = target.dataset.variantid;
    if (!variantId) {
      console.error('Variant ID not found.');
      return; // Exit the function if the variant ID is not found
    }

    console.log(JSON.stringify({
      quantity: 1,
      id: variantId,
      properties: {
        Message,
        "Personalisation": personalizationMessage
      },
      sections: "cart-drawer-giftflow,cart-icon-bubbl,gift-flow",
      'sections_url': window.location.pathname
    }));

    target.classList.add('hidden');
    this.enableLoading(target.parentElement);

    try {
      const parsedResponse = await (await fetch('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify({
          quantity: 1,
          id: variantId,
          properties: {
            Message,
            "Personalisation": personalizationMessage
          },
          sections: "cart-drawer-giftflow,cart-icon-bubble,gift-flow",
          sections_url: window.location.pathname
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      })).json();

      this.renderContents(parsedResponse);
      // const giftFlowContainer = document.querySelector(".twelve-days");
      // console.log("giftFlowContainer: ", giftFlowContainer);
      // if (giftFlowContainer && parsedResponse.sections["gift-flow"]) {
      //   giftFlowContainer.innerHTML = parsedResponse.sections["gift-flow"];
      // }
    } catch (error) {
      console.error('Error adding to cart:', error);
    }
  }



  assignCardEvents() {
    const giftCardList = this.querySelector('[data-initialised]');

    if (giftCardList?.dataset?.initialised === 'true') {
      return;
    }

    this.querySelectorAll('.quickadd-variant')
      .forEach((el) => {
        console.log("el: ", el);
        el.addEventListener('click', this.handleQuickAddClick.bind(this));
      });

    if (!giftCardList) return

    giftCardList.dataset.initialised = true;
  }

  checkPersonalisedImages() {
    async function cartImageFallback(el) {
      if (!el.dataset.fallback) return;
      try {
        await el.decode();
      } catch (error) {
        console.warn('Fallback used for', el.src);
        el.src = el.dataset.fallback;
        await el.decode();
      }
    }
    [...document.querySelectorAll('.cart-item__image')].forEach((e) => cartImageFallback(e));
  }

  enableLoading(el) {
    const overlay = el.querySelector('.loading-overlay__spinner');

    overlay.classList.remove('hidden');

    document.activeElement.blur();
  }

  close() {
    this.classList.remove('active');
    // close personalisation and bundle accordions
    closeAllAccordions();
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;

    console.log("parsedState: ", parsedState);
    console.log("parsedState.sections: ", parsedState.sections);
    // console.log("parsedState.sections['cart-drawer-giftflow']: ", parsedState.sections['cart-drawer-giftflow']);

    // Add null check for sections
    if (!parsedState.sections) {
      console.error('Error: parsedState.sections is undefined');
      return;
    }

    this.getSectionsToRender().forEach((section => {
      // Check if the section exists before trying to render it
      if (!parsedState.sections[section.id]) {
        console.warn(`Section '${section.id}' not found in response, skipping`);
        return;
      }

      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (!sectionElement) return;
      console.log("sectionElement: ", sectionElement);
      sectionElement.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.setSubPriceSpacing();
      loadDrawerAccordions();
      this.open();
      this.assignCardEvents();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        // id: 'cart-drawer',
        id: 'cart-drawer-giftflow',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      },
      {
        id: 'gift-flow',
        selector: '#the-giftflow'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer-giftflow',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'gift-flow',
        section: 'gift-flow',
        selector: '#the-giftflow'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
